import { render, staticRenderFns } from "./ImportValidatorSettings.vue?vue&type=template&id=3fb8d4ae&scoped=true"
import script from "./ImportValidatorSettings.vue?vue&type=script&lang=js"
export * from "./ImportValidatorSettings.vue?vue&type=script&lang=js"
import style0 from "./ImportValidatorSettings.vue?vue&type=style&index=0&id=3fb8d4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8d4ae",
  null
  
)

export default component.exports